// extracted by mini-css-extract-plugin
export default {"helpModalContainer":"ShipmentCard_helpModalContainer__KsesR"};